import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.page.DOC}
  query MosaicPageForDev(
    $tenantId: ID!
    $zoneId: ID!
    $identifier: FlexibleIdentifierInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        mosaicDev {
          page(identifier: $identifier) {
            ...FragmentMosaicPageForDev
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.MosaicPageForDevQuery,
  ents.core.mosaic.Page | undefined,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select(
      'mosaicDev',
      graphql.transformers.OUT.select('page', fragments.page.TRANSFORMER),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.MosaicPageForDevQuery,
  ents.core.mosaic.Page | undefined,
  graphql.schema.MosaicPageForDevQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
